
import {Component, Vue} from "vue-property-decorator"
import {apiNewsDetail, apiNewsShopLists} from "@/api/shop"
import {debounce} from '@/utils/util'
import {apiCollectionAdd, apiCollectionDetail, apiCollectionEdit} from '@/api/collection'

@Component({})
export default class CollectionEdit extends Vue {
  identity: number | null = null; // 当前编辑用户的身份ID
  submitLoading = false;
  shopData: any[] = [];
  form = {
    name: [''] as string | string[], // 统一使用name字段，新增时为数组，编辑时为字符串
    sid: '',
    upload_time: '' as string | Date
  };

  rules = {
    sid: [
      {required: true, message: '请选择商户', trigger: 'blur'}
    ],
    name: [
      {required: true, message: '请输入分类名称', trigger: 'blur'}
    ],
    upload_time: [
      {required: true, message: '请选择上传时间', trigger: 'change'}
    ]
  };

  // async mounted() {
  //   const id = this.$route.query.id;
  //   if (id) {
  //     // this.form.id = Number(id);
  //     await this.getDetail();
  //   }
  // }

  async getShopListsFn(): Promise<void> {
    const res: any = await apiNewsShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.data;
  }


  async getDetail(): Promise<void> {
    const res = await apiCollectionDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }


  // 添加name输入框
  addName() {
    if (!Array.isArray(this.form.name)) {
      this.form.name = [this.form.name as string];
    }
    this.form.name.push('');
  }

  // 删除name输入框
  removeName(index: number) {
    if (Array.isArray(this.form.name)) {
      this.form.name.splice(index, 1);
    }
  }

  // 修改 onSubmit 方法，确保正确验证所有字段
  async onSubmit() {
    // 根据模式动态设置验证规则
    if (this.identity) {
      // 编辑模式只需要验证name
      (this.$refs.form as any).validate(async (valid: boolean) => {
        if (valid) {
          this.submitLoading = true;
          try {
            await apiCollectionEdit(this.form);
            // this.$message.success('编辑成功');
            this.$router.back();
          } finally {
            this.submitLoading = false;
          }
        } else {
          this.$message.error('请检查表单填写是否正确');
        }
      });
    } else {
      // 新增模式需要验证每个name项
      (this.$refs.form as any).validate(async (valid: boolean) => {
        if (valid) {
          this.submitLoading = true;
          try {
            // 新增模式下将names数组转换为多个记录
            // const names = Array.isArray(this.form.name) ? this.form.name : [this.form.name];
            // for (const name of names) {
            //   if (name.trim()) {
                await apiCollectionAdd({
                  ...this.form,
                  // name: name
                });
              // }
            // }
            // this.$message.success('新增成功');
            this.$router.back();
          } finally {
            this.submitLoading = false;
          }
        } else {
          this.$message.error('请检查表单填写是否正确');
        }
      });
    }
  }


  created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      this.getDetail()
    }
    // 获取商城列表是数据
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)

  }
}
